import { useEffect } from "react";

export default function useEffectOnMount(effect: React.EffectCallback) {
  useEffect(effect, []);
}
